import { Outlet } from 'react-router-dom';

const Kyc = () => {
  return <Outlet />;
};

export default Kyc;
